"use client";

import InitAnalytics from "@/components/init-analytics";
import OnlyClient from "@/utils/OnlyClient";

export default function Template({ children }: { children: React.ReactNode }) {
  return (
    <>
      <InitAnalytics />
      <OnlyClient>
        <>{children}</>
      </OnlyClient>
    </>
  );
}
